import { useState } from "react";
import { Users, GraduationCap, ClipboardList } from "lucide-react";
import { Tabs, TabPanel, type Tab } from "@/components/ui/Tabs";
import { VolunteerList } from "@/features/volunteers/VolunteerList";
import { VolunteerTraining } from "@/features/volunteers/VolunteerTraining";
import { VolunteerRoster } from "@/features/volunteers/VolunteerRoster";

const volunteerTabs: Tab[] = [
  { id: "list", label: "Volunteers", icon: Users },
  { id: "training", label: "Training", icon: GraduationCap },
  { id: "roster", label: "Roster", icon: ClipboardList },
];

export function VolunteersPage() {
  const [activeTab, setActiveTab] = useState("list");

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Volunteers</h1>
        <p className="text-sm text-muted-foreground">
          Manage volunteers, training records, and activity hours.
        </p>
      </div>

      <Tabs tabs={volunteerTabs} activeTab={activeTab} onChange={setActiveTab} />

      <TabPanel id="list" activeTab={activeTab}>
        <VolunteerList />
      </TabPanel>

      <TabPanel id="training" activeTab={activeTab}>
        <VolunteerTraining />
      </TabPanel>

      <TabPanel id="roster" activeTab={activeTab}>
        <VolunteerRoster />
      </TabPanel>
    </div>
  );
}
